import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { noop } from 'rxjs';
import {
  BaseAvatarSize,
  BaseInquiryService,
  BaseModalHeaderSizes,
  BaseModalService,
  CustomerOfferListItemResponse,
  RequirementResponse,
} from 'base';

@Component({
  selector: 'base-customer-dashboard-offer-card',
  templateUrl: './base-customer-dashboard-offer-card.component.html',
})
export class BaseCustomerDashboardOfferCardComponent implements OnInit {
  @ViewChild('requirementsPopup', { static: true }) requirementsPopup: ElementRef;
  @Input() isRecent: boolean;
  @Input() offer: CustomerOfferListItemResponse;

  offerInquiryRequirements: RequirementResponse[];
  offerCandidateRequirements: RequirementResponse[];
  allRequirementsFulfilled: boolean;
  recent: number;
  modalRef: NgbModalRef;

  BaseAvatarSize = BaseAvatarSize;

  constructor(
    private modalService: BaseModalService,
    private baseInquiryService: BaseInquiryService,
    private router: Router
  ) {}

  ngOnInit() {
    this.setRequirementsData();
  }

  openRequirementsModal(event: Event): void {
    event.stopPropagation();
    this.modalRef = this.modalService.open(
      {
        headText: !!this.offerInquiryRequirements.length ? 'inquiry.requirementsFor' : 'inquiry.noRequirementsSet',
        headTextTranslateParams: { fullName: `${this.offer.profile?.firstName} ${this.offer.profile?.lastName}` },
        headerSize: BaseModalHeaderSizes.sm,
        bodyTemplate: this.requirementsPopup,
        okText: 'action.close',
        cancelButtonDisplayed: false,
        cancelButtonOnly: true,
      },
      {
        scrollable: false,
        backdrop: 'static',
        size: 'lg',
      }
    );

    this.modalRef.result.then(noop, noop);
  }

  openNoteFromProviderModal(event: Event): void {
    event.stopPropagation();
    if (this.offer.note) {
      this.modalRef = this.modalService.open(
        {
          headText: 'Note from Provider',
          bodyText: this.offer.note,
          okText: 'action.close',
          cancelButtonDisplayed: false,
          cancelButtonOnly: true,
        },
        {
          scrollable: false,
          backdrop: 'static',
          size: 'lg',
        }
      );

      this.modalRef.result.then(noop, noop);
    }
  }

  openIzsInfoModal(event: Event): void {
    event.stopPropagation();
    this.router.navigate(['/service-provider'], {
      queryParams: {
        page: 1,
        search: this.offer.pspBranch.name,
        pspBranchId: this.offer.pspBranch.id,
        location: this.offer.location.id,
      },
    });
  }

  private setRequirementsData(): void {
    this.offerInquiryRequirements = this.baseInquiryService.ungroupRequirements(this.offer.inquiry?.requirements);
    this.offerCandidateRequirements = this.baseInquiryService.ungroupRequirements(this.offer.profile?.requirements);
    this.allRequirementsFulfilled = this.offerInquiryRequirements.every((inquiryRequirement) =>
      this.offerCandidateRequirements.some((candidateRequirement) => candidateRequirement.id === inquiryRequirement.id)
    );
  }
}
